// extracted by mini-css-extract-plugin
module.exports = {"root":"message-wrapper_root__TZ4BL","variant-left-bottom":"message-wrapper_variant-left-bottom__go50H","variant-right-bottom":"message-wrapper_variant-right-bottom__ku7JE"};